import React from 'react';

export const TrainingZoneAnalytics: React.FC = () => {
	return (
		<div>
<iframe title="Enablement" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=44e36c54-66af-41c2-afd8-922491913294&autoAuth=true&ctid=ba43003a-491b-4811-8473-d6fcde34296d" frameBorder="0" allowFullScreen={true}	></iframe>

		</div>
	);
};

export default TrainingZoneAnalytics;